import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export interface IArticle {
    readonly category: string;
    readonly available: boolean;
}

export interface IArticleInformationData {
    readonly vehicles: [
        {
            vin: string,
            articles: IArticle[]
        }
    ] | [];
}

// https://vw-car-net.qs-shop-volkswagen-we.com/documentation/shop
export class CarNetShopClient {

    private readonly resourceHostId;

    constructor(private readonly authServiceWeConnect: IAuthServiceV2, private readonly stage: string) {
        this.resourceHostId = `myvw-car-net-shop-${stage}`;
    }

    // https://vw-car-net.qs-shop-volkswagen-we.com/documentation/shop/#/Checkout%20Data/getArticleInformation
    public async getArticleInformation(vin: string, isWcar: boolean, shopCountry: string, shopLocale: string): Promise<IArticleInformationData> {
        const url = `vw/de/v3/checkout/__userId__/article-information?gdc=${this.getGdcType(isWcar)}&vin=${vin}&shop-country=${shopCountry}&shop-locale=${shopLocale}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url);

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }

    private getGdcType(isWcar: boolean) {
        return isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
    }

}
